module.exports = __webpack_public_path__ + "static/media/website-vannya-momentum.5582c3f6.png";